// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CallIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CallIcon" ref={forwardedRef} {...props}>
      <path d="M10.806 3.502c3.247 0 5.706 2.491 5.706 5.31H18c0-3.725-3.204-6.81-7.194-6.81z" />
      <path d="M4.598 3.57a1.726 1.726 0 0 1 2.276.158l1.522 1.534a1.26 1.26 0 0 1 .148 1.586l-1 1.484c.463 1.356.85 2.111 1.388 2.653.539.543 1.291.935 2.643 1.406l1.5-1a1.23 1.23 0 0 1 1.56.16l1.455 1.465a1.76 1.76 0 0 1 .157 2.293l-1.215 1.62c-.618.824-1.682 1.273-2.736.982-5.13-1.416-8.88-5.211-10.218-10.449C1.81 6.411 2.255 5.36 3.06 4.744zm1.224 1.22a.25.25 0 0 0-.325-.023L3.959 5.94c-.382.291-.542.746-.44 1.148 1.205 4.713 4.552 8.101 9.17 9.377.403.11.863-.05 1.156-.44l1.215-1.62a.25.25 0 0 0-.022-.328l-1.312-1.322-1.935 1.29-.343-.114c-1.592-.532-2.72-1.03-3.568-1.885-.849-.855-1.342-1.991-1.866-3.593l-.115-.35 1.3-1.927z" />
      <path d="M13.225 8.812c0-1.173-1.023-2.25-2.419-2.25v-1.5c2.153 0 3.907 1.684 3.907 3.75z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CallIcon = /* @__PURE__ */ Object.assign(CallIconComponent, {
  displayName: 'CallIcon',
});
